import NameEmail from './name-email.entity';

export default class Survey {
  workItems: string[];

  recipients: NameEmail[];

  deliveryName: string;

  singleDelivery: boolean = false;

  linkSurvey: string;

  language: string;

  constructor(obj: any = {}) {
    this.workItems = obj.workItems || [];
    this.recipients = obj.recipients
      ? obj.recipients.map((it: any) => new NameEmail(it))
      : [new NameEmail()];
    this.deliveryName = obj.deliveryName || '';
    this.singleDelivery = obj.singleDelivery;
    this.linkSurvey = obj.linkSurvey;
    this.language = obj.language || 'Português (PT-BR)';
  }

  public pushNewRecipient(): void {
    this.recipients.push(new NameEmail());
  }

  public removeRecipient(index: number): void {
    this.recipients.splice(index, 1);
  }
}
